import React, { useEffect, useState, useRef } from "react";
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import HdrAutoIcon from '@mui/icons-material/HdrAuto';
import { useStreamProvider } from "../../api/StreamProvider";
import { usePoserProvider } from "../../api/PoserProvider";
import { useHandsProvider } from "../../api/HandsProvider";
import Radio from '@material-ui/core/Radio';
import data_hands from '../../assets/temp/data.json' 
import ScoreBarComponent from '../utils/ScoreBarComponent';
import {getReportDevice} from '../../api/utils/device';




import CloseIcon from '@material-ui/icons/Close';
// import bodyReference from "../../assets/imgs/bodyReferenceAR.png"

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { LinearProgress } from "@material-ui/core";

import { Tabs, Tab } from "@material-ui/core";
import { pCameraTesterTab, pCameraTesterState } from "../../utils/parameters";
import { ButtonGroup, Grid, FormControlLabel, Switch, Button, Paper, Box, Divider } from "@material-ui/core";
import HelpIcon from '@mui/icons-material/Help';


import bodyReference from "../../assets/imgs/galibo20.bmp"
import cameraTesterVidRef from "../../assets/videos/cameraTester/VideoReferenceOLD.mp4"
import { useStyles } from "../../styles/SignDialog";
import { useTimerProvider } from '../../api/TimerProvider';
import Typography from '@material-ui/core/Typography';

import { useVideoSyncMonitor } from "../../api/VideoSyncMonitor";





import "../../styles/devices/mob_cameraTester.css";
import { set } from "lodash";


export function CameraTester(props) {
  const { openCameraTester, setOpenCameraTester, setRecord_trigger } = props

  const [ tabValue, setTabValue ] = useState(null);
  const styles = useStyles();

  const main_videoCanvasRef = useRef(null);
  const canvasRef = useRef(null);
  const canvasIndicatorRef = useRef(null);

  const [isMirrored, setIsMirrored] = useState(true);
  const intervalIdRef = useRef(null); 

  const [ openDialogVid, setOpenDialogVid ] = useState(false)
  const [ textDialogVid, setTextDialogVid ] = useState("")

  const [ openDialogShowInfo, setOpenDialogShowInfo ] = useState(pCameraTesterTab.none)
  const [ stateCameraTester, setStateCameraTester ] = useState(pCameraTesterState.NONE)

  const [ openDialogScoreDetails, setOpenScoreDetails ] = useState(false)
  const [ openWarningQuiet, setOpenWarningQuiet ] = useState(false)

  const kpsHL = useRef(0)
  const kpsHR = useRef(0)
  const kpsHEAD = useRef(0)
  const kpsHIP = useRef(0)
  
  const arr_kps_HL = useRef([15, 17, 19, 21])
  const arr_kps_HR = useRef([16, 18, 20, 22])
  const arr_kps_HEAD = useRef([0, 2, 5, 7, 8, 9, 10])
  const arr_kps_HIP = useRef([24, 23])

  const [ statusDetectionHL, setStatusDetectionHL ] = useState(false)
  const [ statusDetectionHR, setStatusDetectionHR ] = useState(false)
  const [ statusDetectionHEAD, setStatusDetectionHEAD ] = useState(false)
  const [ statusDetectionHIP, setStatusDetectionHIP ] = useState(false)

  const statusDetectionHLRef = useRef(null);
  const statusDetectionHRRef = useRef(null);
  const statusDetectionHEADRef = useRef(null);
  const statusDetectionHIPRef = useRef(null);

  const counterDelayDetection = useRef(0);
  
  const [ avgScoreHANDS, setAvgScoreHANDS ] = useState(0)
  const [ avgScoreHEAD, setAvgScoreHEAD ] = useState(0)
  const [ avgScoreGLOBAL, setAvgScoreGLOBAL ] = useState(0)
  
  // const [ avgQuiet, setAvgQuiet ] = useState(0)

  const [ quiteHandsDetected, setQuiteHandsDetected ] = useState(false)

  const THRESHOLD_SCORE_QUALITY_VIDEO = 0.5
  const [ evalSuccess, setEvalSuccess ] = useState(false)

  const { 
      timer, 
      timerActive, 
      setConfigTimer, 
      stopTimer 
  } = useTimerProvider();

  const area_HL = useRef({
    'xmin': 0.69,
    'xmax': 0.84,
    'ymin': 0.77,
    'ymax': 1,
  })

  const area_HR = useRef({
    'xmin': 0.18,
    'xmax': 0.33,
    'ymin': 0.77,
    'ymax': 1,
  })

  const area_HEAD = useRef({
    'xmin': 0.40,
    'xmax': 0.62,
    'ymin': 0.12,
    'ymax': 0.33,
  })

  const area_HIP = useRef({
    'xmin': 0.18,
    'xmax': 0.84,
    'ymin': 0.77,
    'ymax': 1,
  })

  const { 
    streamVideoWidthRef,
    streamVideoHeightRef,
    streamVideoOriginal,
    streamVideoOut, 
    streamMediaBlobUrl,
    setStreamMediaBlobUrl,
    videoRevisedRef
  } = useStreamProvider();

  const { 
    statusPoser,
    setStatusPoser,
    poseDataRef,
    bufferPoseDataRef
  } = usePoserProvider();

  const { 
    statusHands,
    setStatusHands,
    handsDataRef,
    bufferHandsDataRef
  } = useHandsProvider();

  const {
    setForceStartVideoReference
  } = useVideoSyncMonitor();


  const initPositionEvaluation = () => {
    // setStatusPoser(true)
    setStatusPoser(true)
    // setStatusHands(true)
      const image = new Image();
      image.src = bodyReference;
      image.onload = () => {
        const context = canvasRef.current.getContext('2d')
        context.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
        context.imageSmoothingEnabled = true;
        context.globalCompositeOperation = 'source-over';
        context.drawImage(image, 0, 0, canvasRef.current.width, canvasRef.current.height);
    };
  } 

  useEffect(() => {
    if (openCameraTester){
      if (main_videoCanvasRef.current) {
        main_videoCanvasRef.current.srcObject = streamVideoOut;
      }
      setTabValue(pCameraTesterTab.position)
    }else{
      setStatusHands(false)
    }

    return () => {
      setTabValue(null)
      setStatusHands(false)
      setStatusPoser(false)
      stopTimer()
    }
  }, [openCameraTester]);


  useEffect(() => {

    counterDelayDetection.current = 0   // Restart counter
    statusDetectionHLRef.current=false
    statusDetectionHRRef.current=false
    statusDetectionHEADRef.current=false
    statusDetectionHIPRef.current=false

    setStatusDetectionHEAD(false)
    setStatusDetectionHR(false)
    setStatusDetectionHL(false)
    setStatusDetectionHIP(false)


    if (tabValue == pCameraTesterTab.position) {
      // setOpenDialogShowInfo(pCameraTesterTab.position)
      // setConfigTimer({
      //   'label': 'DialogShowInfo',
      //   'start': 1,
      //   'end': 0,
      //   'step': 1,
      //   'interval_ms': 50,
      //   'onEnd': () => { initPositionEvaluation(); setOpenDialogShowInfo(pCameraTesterTab.none)}
      // })

      initPositionEvaluation()
      setOpenDialogShowInfo(pCameraTesterTab.none)
      
    }else{
      // setStatusPoser(false)
      setStatusHands(false)
    }

    if (tabValue == pCameraTesterTab.video){
      setStatusHands(true)
      setStatusPoser(true)
    //   setOpenDialogShowInfo(pCameraTesterTab.video)
    //   setConfigTimer({
    //         'label': 'DialogShowInfo',
    //         'start': 1,
    //         'end': 0,
    //         'step': 1,
    //         'interval_ms': 50,
    //         'onEnd': () => {{ setConfigTimer({'label': 'Counter','start': 3,'end': 0,'step': 1,'interval_ms': 700,'onEnd': () => {}}) ; setOpenDialogShowInfo(pCameraTesterTab.none), setOpenDialogVidRef(true) }}
    //     })
    // }

      // setConfigTimer({
      //   'label': 'PreVidRef',
      //   'start': 3,
      //   'end': 0,
      //   'step': 1,
      //   'interval_ms': 600,
      //   'onEnd': () => {setTextDialogVid("PlayVidRef")}
      // })
      setOpenDialogShowInfo(pCameraTesterTab.none)
      //setOpenDialogVid(true)
      setStateCameraTester(pCameraTesterState.PRE_VID_REF)
    }



  }, [tabValue]);


  useEffect(() => {
    if (main_videoCanvasRef.current) {
      main_videoCanvasRef.current.srcObject = streamVideoOut;
    }
  }, [streamVideoOut]);


  const check_kps_location = (kp_data, arr_idx, area, label) =>{
    if (kp_data === undefined) {
      return 0;
    }
    let counter = 0
    arr_idx.forEach(index => {
      counter = counter + (kp_data[index].x > area.xmin && kp_data[index].x < area.xmax && kp_data[index].y > area.ymin && kp_data[index].y < area.ymax)
    });
    counter = counter / arr_idx.length;
    return counter
  }

  useEffect(() => {
    if (statusPoser) {
      console.log('POSEDATAREF: ACTIVADO');
      intervalIdRef.current = setInterval(() => {
        kpsHR.current = check_kps_location(poseDataRef.current['landmarks'][0], arr_kps_HR.current, area_HR.current, "HR")
        // console.log("🚀 ~ intervalIdRef.current=setInterval ~ kpsHR:", kpsHR.current)
        kpsHL.current = check_kps_location(poseDataRef.current['landmarks'][0], arr_kps_HL.current, area_HL.current, "HL")
        // console.log("🚀 ~ intervalIdRef.current=setInterval ~ kpsHL:", kpsHL.current)
        kpsHEAD.current = check_kps_location(poseDataRef.current['landmarks'][0], arr_kps_HEAD.current, area_HEAD.current, "HEAD")

        kpsHIP.current = check_kps_location(poseDataRef.current['landmarks'][0], arr_kps_HIP.current, area_HIP.current, "HIP")
        // console.log("🚀 ~ intervalIdRef.current=setInterval ~ kpsHEAD:", kpsHEAD.current)
        if (statusPoser){
          updateCanvasIndicator()
          updateTrigger()
        }
        
      }, 250);
    } else {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
        intervalIdRef.current = null;
      }
      if (canvasIndicatorRef.current){
        canvasIndicatorRef.current.getContext('2d').clearRect(0, 0, canvasIndicatorRef.current.width, canvasIndicatorRef.current.height);
      }

    }
  }, [statusPoser]);


  const updateCanvasIndicator = () => {
    if (canvasIndicatorRef && canvasIndicatorRef.current) {
      const context = canvasIndicatorRef.current.getContext('2d')
      context.clearRect(0, 0, canvasIndicatorRef.current.width, canvasIndicatorRef.current.height);

      const convertRgbToRgba = (rgb, alpha) => {
        let numbers = rgb.match(/\d+/g).map(Number);
        return `rgba(${numbers[0]}, ${numbers[1]}, ${numbers[2]}, ${alpha})`;
      } 

      const drawRect = (x, y, width, height, color, kpsCounter, detected) => {
        context.beginPath();
        context.rect(x, y, width, height);
        context.strokeStyle = convertRgbToRgba(color, 1);
        context.lineWidth = 1
        context.stroke();

        if (detected){
          // console.log("🚀 ~ drawRect ~ detected:", detected)
          context.fillStyle = convertRgbToRgba(color, 0.5);
        }else{
          // console.log("🚀 ~ drawRect ~ detected:", detected)
          context.fillStyle = convertRgbToRgba(color, 0.1 * kpsCounter);
        }
        
        context.fill();
      };

      const obtainZYWH = (area) => {
        let coordenates = {}
        coordenates['x'] = area.xmin * canvasIndicatorRef.current.width;
        coordenates['y'] = area.ymin * canvasIndicatorRef.current.height;
        coordenates['w'] = (area.xmax - area.xmin) * canvasIndicatorRef.current.width;
        coordenates['h'] = (area.ymax - area.ymin) * canvasIndicatorRef.current.height;
        return coordenates
      }

      const coor_HEAD = obtainZYWH(area_HEAD.current)
      drawRect(coor_HEAD.x, coor_HEAD.y, coor_HEAD.w, coor_HEAD.h,  `rgb(255, 0, 0)`, kpsHEAD.current, statusDetectionHEADRef.current);

      // Draw the blue rectangle
      const coor_HIP = obtainZYWH(area_HIP.current)
      drawRect(coor_HIP.x, coor_HIP.y, coor_HIP.w, coor_HIP.h,  `rgb(0, 0, 255)`, kpsHIP.current, statusDetectionHIPRef.current);

      // Draw the green rectangle
      const coor_HL = obtainZYWH(area_HL.current)
      drawRect(coor_HL.x, coor_HL.y, coor_HL.w, coor_HL.h,  `rgb(0, 255, 0)`, kpsHL.current, statusDetectionHLRef.current);

      // Draw the green rectangle
      const coor_HR = obtainZYWH(area_HR.current)
      drawRect(coor_HR.x, coor_HR.y, coor_HR.w, coor_HR.h,  `rgb(0, 255, 0)`, kpsHR.current, statusDetectionHRRef.current);
    }

  }

  const updateTrigger = () => {
    const THRESHOLD = 0.7
    const THRESHOLD_DETECTION = 3

    const detectedHL = kpsHL.current > THRESHOLD
    const detectedHR = kpsHR.current > THRESHOLD
    const detectedHEAD = kpsHEAD.current > THRESHOLD
    const detectedHIP = kpsHIP.current > THRESHOLD

    // setStatusDetectionHL(detectedHL)
    // setStatusDetectionHR(detectedHR)
    // setStatusDetectionHEAD(detectedHEAD)
    // setStatusDetectionHIP(detectedHIP)

    statusDetectionHLRef.current = detectedHL
    statusDetectionHRRef.current = detectedHR
    statusDetectionHEADRef.current = detectedHEAD
    statusDetectionHIPRef.current = detectedHIP

    setStatusDetectionHEAD(detectedHEAD)
    setStatusDetectionHR(detectedHR)
    setStatusDetectionHL(detectedHL)
    setStatusDetectionHIP(detectedHIP)


     if (detectedHL && detectedHR && detectedHEAD && detectedHIP) {
      counterDelayDetection.current = counterDelayDetection.current + 1

      if (counterDelayDetection.current > THRESHOLD_DETECTION) {

        console.log('COUNTER DELAY DETECTION OK videoRevisedRef.current  >> ', videoRevisedRef.current)

        if (videoRevisedRef.current == false){
          setTabValue(pCameraTesterTab.video)
        }else{
          setOpenCameraTester(false)
          setRecord_trigger(new Date().getTime())
        }
      }

    }else{
      counterDelayDetection.current = 0
      // setStatusDetectionHL(false)
      // setStatusDetectionHR(false)
      // setStatusDetectionHEAD(false)
    }

  }

  const handleEndVidRefence = () => {

    // Resetar buffer manos
    bufferPoseDataRef.current = []
    bufferHandsDataRef.current = []
    setAvgScoreHANDS(0)
    setAvgScoreHEAD(0)
    setAvgScoreGLOBAL(0)
    setEvalSuccess(false)
    // setAvgQuiet(0)
    setQuiteHandsDetected(false)
    
    setStateCameraTester(pCameraTesterState.POST_VID_REF)
  }

  const handleResultsPoseHands = () =>{

    // console.log("🚀 ~ handleResultsPoseHands ~ handleResultsPoseHands:", handleResultsPoseHands)
    // console.log("🚀 ~ handleResultsPoseHands ~ bufferPoseDataRef:", bufferPoseDataRef)
    // console.log("🚀 ~ handleResultsPoseHands ~ bufferHandsDataRef:", bufferHandsDataRef)
    // console.log('DATA_HANDS', data_hands)

    let scoresHANDS = [];
    bufferHandsDataRef.current.forEach((dato) => {
      let handedness = dato.handedness;
      for (let i = 0; i < 2; i++) {
        if (handedness[i] === undefined){
          scoresHANDS.push(0);
        } else{
          scoresHANDS.push(handedness[i][0]['score']);
        }
      }
    });

    const sumHANDS = scoresHANDS.reduce((a, b) => a + b, 0);
    const avgHANDS = (sumHANDS / scoresHANDS.length) || 0;

    ////// SCORE KPS HEAD

    let scoresHEAD = [];
    bufferPoseDataRef.current.forEach((dato) => {
      // Solo evaluaré el punto central de la cara / nariz.
      scoresHEAD.push(check_kps_location(dato['landmarks'][0], [0], area_HEAD.current, "HR"))
    });
    const sumHEAD = scoresHEAD.reduce((a, b) => a + b, 0);
    const avgHEAD = (sumHEAD / scoresHEAD.length) || 0;


    ////// AVERAGE SCORE HANDS & SCORE HEAD

    const avgGLOBAL = (avgHANDS * 0.65) + (avgHEAD * 0.35 )

    setAvgScoreHANDS(avgHANDS)
    setAvgScoreHEAD(avgHEAD)
    setAvgScoreGLOBAL(avgGLOBAL)
    if ( avgGLOBAL > THRESHOLD_SCORE_QUALITY_VIDEO ){
      setEvalSuccess(true)
    }

    // console.log("🚀 ~ handleResultsPoseHands ~ avgHANDS:", avgHANDS)
    // console.log("🚀 ~ handleResultsPoseHands ~ avgHEAD:", avgHEAD)
    // console.log("🚀 ~ handleResultsPoseHands ~ avgGLOBAL:", avgGLOBAL)

    //// CALCULATE IF IS MOVING
    let hl_larkmarks = [];
    let hr_larkmarks = [];
    let counter_error = 0
    bufferPoseDataRef.current.forEach((dato) => {
      try{
        hl_larkmarks.push(dato.landmarks[0][15])
        hr_larkmarks.push(dato.landmarks[0][16])
      }catch{
        counter_error = counter_error + 1
      }
    });
    

    const calculate_is_quite = (data, margin, threshold) =>{
      let counter_quite_frames = 0
      for (let i = 0; i < data.length - margin; i++) {
        let diff = 0
        if (data[i].y >= 0 && data[i].y <= 1 && data[i].x >= 0 && data[i].x <= 1){
          diff = Math.sqrt(Math.pow(data[i].x - data[i + margin].x, 2) + Math.pow(data[i].y - data[i + margin].y, 2));
        }
        if (diff < threshold) {
          counter_quite_frames++;
        }
      }
      return (counter_quite_frames + counter_error) / data.length
      // Cuanto mas alto más procentaje de quietos o errores
    }

    const margin = 4
    const threshold = 0.01;
    const quiteHL = calculate_is_quite(hl_larkmarks, margin, threshold)
    const quiteHR = calculate_is_quite(hr_larkmarks, margin, threshold)
    // console.log("🚀 ~ handleResultsPoseHands ~ conf:", margin, threshold)
    // console.log("🚀 ~ handleResultsPoseHands ~ quiteHL:", quiteHL)
    // console.log("🚀 ~ handleResultsPoseHands ~ quiteHR:", quiteHR)
    // setAvgQuiet( (quiteHL + quiteHR) / 2)
    // setAvgQuiet(Math.max(quiteHL, quiteHR));

    if ( Math.max(quiteHL, quiteHR) > 0.5 ){
      setQuiteHandsDetected(true)
    }else{
      setQuiteHandsDetected(false)
    }

    bufferPoseDataRef.current = []
    bufferHandsDataRef.current = []
  }

  function showTutorial(){
    // console.log("🚀 ~ file: Teams.js:215 ~ showTutorial ~ showTutorial:", showTutorial)
    const URL = 'https://efficient-check-bb3.notion.site/C-mo-puedo-mejorar-mis-grabaciones-708e39d6764b4779a0263254cb400a8a'
    window.open(URL, "_blank", "noopener,noreferrer");
  }
    

  const forceClose = () =>{
    videoRevisedRef.current = false
    setOpenCameraTester(false)
  }

  const endVideoEvaluation = () => {
    console.log("🚀 ~ endVideoEvaluation ~ endVideoEvaluation:", endVideoEvaluation)
    videoRevisedRef.current = true
    setOpenCameraTester(false)
    setForceStartVideoReference(new Date().getTime())
  }

  const forceInitRecord = () =>{
    setOpenCameraTester(false)
    setRecord_trigger(new Date().getTime())
  }


  useEffect(() => {

    console.log("🚀 ~ stateCameraTester ~ stateCameraTester:", stateCameraTester)

    if (stateCameraTester === pCameraTesterState.PRE_VID_REF){
      setConfigTimer({
        'label': 'PRE_VID_REF',
        'start': 3,
        'end': 0,
        'step': 1,
        'interval_ms': 750,
        'onEnd': () => { setStateCameraTester(pCameraTesterState.VID_REF)}
      })
      setOpenDialogVid(true)
      setTextDialogVid("Atención al vídeo")
    }

    if (stateCameraTester === pCameraTesterState.VID_REF){
      setOpenDialogVid(true)
    }

    if (stateCameraTester === pCameraTesterState.POST_VID_REF){
      setConfigTimer({
        'label': 'POST_VID_REF',
        'start': 3,
        'end': 0,
        'step': 1,
        'interval_ms': 750,
        'onEnd': () => { setStateCameraTester(pCameraTesterState.RECORDING)}
      })
      setOpenDialogVid(true)
      setTextDialogVid("Ahora repite tú")
    }

    if (stateCameraTester === pCameraTesterState.RECORDING){
      setConfigTimer({
        'label': 'Recording',
        'start': 4,
        'end': 0,
        'step': 1,
        'interval_ms': 1000,
        'onEnd': handleResultsPoseHands
      })
      setOpenDialogVid(false)
    }

  }, [stateCameraTester]);

  const showReportDevice = () => {
    getReportDevice()
  }



  return (
    <>
    {openCameraTester ? (
      <div style={{ 
        position: 'absolute', 
        top: 0, 
        left: 0, 
        width: '100%', 
        height: '100%', 
        backgroundColor: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9
      }}>

        <div>
        <Tabs
            className="sig_SignModal_Tabs"
            value={tabValue}
            // onChange={(event, newValue) => {
            //   setTabValue(newValue);
            // }}
            indicatorColor="primary"
            textColor="primary"
            centered
            style={{position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', minWidth: '50%'}}
          >
          
          <Tab style={tabValue === pCameraTesterTab.position ? {backgroundColor: '#5ea0d4', color: 'white', borderRadius: "20px 20px 0px 0px", border: '2px solid #5ea0d4'} : {}} className="sig_SignModal_Tab" label= "EVALUAR POSICIÓN" />
          <Tab style={tabValue === pCameraTesterTab.video ? {backgroundColor: '#5ea0d4', color: 'white', borderRadius: "20px 20px 0px 0px", border: '2px solid #5ea0d4'} : {}} className="sig_SignModal_Tab" label= "EVALUAR CALIDAD" />

        </Tabs>
        {/* 
          <Button onClick={forceInitRecord}>End evaluation </Button>
          <Button onClick={showReportDevice}>REPORTE </Button>
        */}
        <IconButton 
          onClick={forceClose} 
          style={{ 
            position: 'absolute', 
            top: 0, 
            right: 0 
          }}
        >
        <CloseIcon color="primary" style={{ fontSize: 50 }} />
        </IconButton>
        <IconButton 
          onClick={() => setOpenDialogShowInfo(tabValue)} 
          style={{ 
            position: 'absolute', 
            top: 0, 
            left: 0
          }}
        >
          <HelpIcon color="primary" style={{ fontSize: 50 }} />
        </IconButton>

        </div>

        <Grid container className="sig_Home_MainSectionContainer">

            {/* </Grid><Grid container className="sig_Home_ButtonsContainerInner" style={{marginTop: '40px', marginBottom: '-20px'}}> */}
            <Grid container className="sig_Home_ButtonsContainerInner" style={{marginTop: '5px', marginBottom: '-20px'}}>
              <Grid item>

              {/* <div style={{flexGrow: 0.1, margin: '5px', display: 'flex', justifyContent: 'center', borderRadius: '20px',  border: '2px solid #5ea0d4', backgroundColor: 'red'}}>
                          <Button onClick={() => setOpenWarningQuiet(true)} style={{ width: '600px', height: '150px', color: 'white', fontSize: '20px', display: 'flex', justifyContent: 'center'}}> 
                            <Box style={{ width: '600px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                              <Box display="flex" justifyContent="space-between"  alignItems="center">
                                  <div style={{width: '240px'}}> NO HAY MOVIMIENTO DE MANOS </div>
                                  <Divider orientation="vertical" flexItem style={{margin: '15px', border: '3px solid white'}} />
                                  <Box style={{ width: '400px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                                    <div>REPITE LA FRASE:</div>
                                    <div>"LUZ CALIDAD REVISAR"</div>
                                  </Box>
                              </Box>
                              <Divider style={{color: 'white', margin: '10px 0', border: '3px solid white'}} />
                                <div>PULSE AQUÍ PARA REPETIR</div>
                            </Box>
                        </Button>
                      </div> */}

                { tabValue === pCameraTesterTab.position &&
                  <Paper style={{
                    padding: '5px', 
                    width: '700px', 
                    boxShadow: 'none', 
                    margin: '0px auto',
                    backgroundColor: (statusDetectionHEAD && statusDetectionHR && statusDetectionHL && statusDetectionHIP) ? '#9df99d' : ''
                  }}>
                    <div className="sig_SignModal_PaperInfo" style={{margin: 'auto', width: '600px', padding: '5px', paddingLeft: '15px', marginTop: '25px', borderRadius: '4px', minHeight: '60px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', border: '2px solid #5ea0d4'}}>
                      
                      <FormControlLabel 
                        control={<Radio checked={statusDetectionHEAD} disabled />} 
                        label={
                          <Typography 
                            style={{ 
                              color: statusDetectionHEAD ? 'green' : 'gray',
                              fontSize: '19px',
                              fontWeight: statusDetectionHEAD ? 'bold' : 'normal'
                            }}
                          >
                            CABEZA
                          </Typography>
                        } 
                        disabled={false} 
                      />
                      <FormControlLabel 
                        control={<Radio checked={statusDetectionHR} disabled />} 
                        label={
                          <Typography 
                            style={{ 
                              color: statusDetectionHR ? 'green' : 'gray',
                              fontSize: '19px',
                              fontWeight: statusDetectionHR ? 'bold' : 'normal'
                            }}
                          >
                            MANO DERECHA
                          </Typography>
                        } 
                        disabled={false} 
                      />
                      <FormControlLabel 
                        control={<Radio checked={statusDetectionHL} disabled />} 
                        label={
                          <Typography 
                            style={{ 
                              color: statusDetectionHL ? 'green' : 'gray',
                              fontSize: '19px',
                              fontWeight: statusDetectionHL ? 'bold' : 'normal'
                            }}
                          >
                            MANO IZQUIERDA
                          </Typography>
                        } 
                        disabled={false} 
                      />

                      <FormControlLabel 
                        control={<Radio checked={statusDetectionHIP} disabled />} 
                        label={
                          <Typography 
                            style={{ 
                              color: statusDetectionHIP ? 'green' : 'gray',
                              fontSize: '19px',
                              fontWeight: statusDetectionHIP ? 'bold' : 'normal'
                            }}
                          >
                            CADERA
                          </Typography>
                        } 
                        disabled={false} 
                      />
                      
                    </div> 
                  </Paper>
                }
                { tabValue === pCameraTesterTab.video &&
                  <Paper style={{
                    padding: '5px', 
                    width: '700px', 
                    boxShadow: 'none', 
                    margin: '0px auto',
                    backgroundColor: '#89cefb17'
                  }}>
                    <div className="sig_SignModal_PaperInfo" style={{
                      marginTop: quiteHandsDetected ? '100px' : '52px',
                      borderRadius: '4px', 
                      minHeight: '60px', 
                      display: 'flex', 
                      justifyContent: 'center', 
                      alignItems: 'center', 
                      border: '2px solid #5ea0d4',
                      gap: '10px'
                    }}>
                    {timerActive ?
                      <>
                        <span style={{fontSize: '22px'}}>  Grabando....  </span>
                        
                      </>
                      :
                      <>

                        { !quiteHandsDetected ?
                          <>
                          <div className="childElement" style={{ flexGrow: 1, marginLeft: '10px' }}>
                            <span style={{fontSize: '17px'}}>  { evalSuccess ? <strong style={{color: 'green'}}>Puntuación (Evaluación superada): </strong> :  <strong style={{color: 'red'}}>Puntuación (Evaluación no superada): </strong> }  </span>
                            <ScoreBarComponent value={(avgScoreGLOBAL*100).toFixed(2)} />
                          </div>
                          <div style={{flexGrow: 0.1, margin: '5px', display: 'flex', justifyContent: 'center', backgroundColor: '#5ea0d4'}}>
                            <Button onClick={() => setOpenScoreDetails(true)} style={{ width: '100%', height: '50px', color: 'white'}}> DETALLES </Button>
                          </div>
                          
                          
                          { (evalSuccess) ? (
                            <div style={{flexGrow: 0.1, margin: '5px', display: 'flex', justifyContent: 'center', backgroundColor: '#5ea0d4'}}>
                              <Button onClick={endVideoEvaluation} style={{ backgroundColor: 'green', width: '100%', height: '50px', color: 'white'}}> TERMINAR EVALUACIÓN </Button>
                            </div>
                            ):(
                              <div style={{flexGrow: 0.1, margin: '5px', display: 'flex', justifyContent: 'center', backgroundColor: '#5ea0d4'}}>
                                <Button onClick={()=> {setTabValue(pCameraTesterTab.position)}} style={{ backgroundColor: 'red', width: '100%', height: '50px', color: 'white'}}> REPETIR EVALUACIÓN </Button>
                              </div>)
                          }
                          </>
                        :
                        <div style={{flexGrow: 0.1, margin: '5px', display: 'flex', justifyContent: 'center', borderRadius: '20px',  border: '2px solid #5ea0d4', backgroundColor: 'red'}}>
                          <Button className="sig_CameraTester_Button_Evaluation" onClick={()=> {setTabValue(pCameraTesterTab.position)}} style={{ width: '600px', height: '150px', color: 'white', fontSize: '20px', display: 'flex', justifyContent: 'center'}}> 
                            <Box style={{ width: '600px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                              <Box display="flex" justifyContent="space-between"  alignItems="center">
                                  <div style={{margin: 'auto', width: '230px'}}> NO HAY MOVIMIENTO DE MANOS </div>
                                  <Divider orientation="vertical" flexItem style={{margin: '15px', border: '3px solid white'}} />
                                  <Box style={{ margin: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                                    <div> REPITE LA FRASE:</div>
                                    <div>"LUZ CALIDAD REVISAR"</div>
                                  </Box>
                              </Box>
                              <Divider style={{color: 'white', margin: '10px 0', border: '3px solid white'}} />
                                <div>PULSE AQUÍ PARA VOLVER A EVALUAR</div>
                            </Box>
                        </Button>
                      </div>
                      
                      }

                      </>
                    }
                    </div>
                    
                  
                  </Paper>
                }
              </Grid>
            </Grid>


          <Grid item>
            <div style={{ display: streamVideoOut === null ? 'none' : 'block' }}>
              <div style={{ position: 'relative' }}>
                <div>
                  <video 
                    ref={main_videoCanvasRef} 
                    id="video_SectionVideo" 
                    autoPlay
                    muted 
                    style={{ 
                      width: '600px', 
                      height: '600px', 
                      objectFit: 'cover', 
                      transform: isMirrored ? 'scaleX(-1)' : 'scaleX(1)'
                    }}
                  />
                  
                  <LinearProgress style={{height: '20px'}} variant="determinate" value={100 * timer / 4} />

                  {pCameraTesterTab.position === tabValue && (
                    <>
                      <canvas 
                        ref={canvasRef} 
                        style={{ 
                          position: 'absolute', 
                          top: 0, 
                          left: 0, 
                          width: '600px', 
                          height: '600px', 
                          zIndex: 2,
                          opacity: 1,
                          transform: isMirrored ? 'scaleX(-1)' : 'scaleX(1)'
                        }}
                      />
                      <canvas 
                        ref={canvasIndicatorRef} 
                        style={{ 
                          position: 'absolute', 
                          top: 0, 
                          left: 0, 
                          width: '600px', 
                          height: '600px', 
                          zIndex: 9,
                          transform: isMirrored ? 'scaleX(-1)' : 'scaleX(1)'
                        }}
                      />
                    </>
                  )}
{/* 
                  <div style={{margin: '5px', display: 'flex', justifyContent: 'center', backgroundColor: '#5ea0d4' }}>
                    <Button onClick={handleResultsPoseHands} style={{ width: '100%', height: '50px', color: 'white'}}> MOSTRAR BUFFERS </Button>
                  </div> */}

                </div>
              </div>
            </div>
            <div style={{ display: streamVideoOut === null ? 'block' : 'none' }}>
              <div style={{ 
                width: '600px', 
                height: '600px', 
                backgroundColor: 'white', 
                objectFit: 'cover', 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center' 
              }}>
                <CircularProgress size={'100px'}/>
              </div>
            </div>
          </Grid>
        </Grid>
        
    </div>
    ): <></>}


      <Dialog className="sig_SignModal_Dialog" open={openDialogVid} onClose={handleEndVidRefence} style={{border: '2px solid red'}}>

        <DialogContent className="sig_SignModal_DialogContent" style={{padding: '10px', width: '600px', height: '670px'}}>
          { stateCameraTester !== pCameraTesterState.VID_REF ? 
                <div style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  textAlign: 'center'
                }}>

                  {timerActive && <>
                    <CircularProgress variant="determinate" size={200} value={100 * timer / 3} />
                    <div style={{
                      fontSize: '30px',
                      fontWeight: 'bold',
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)'
                    }}>
                      {timer}
                    </div>
                  </>}
                  
                  <div style={{
                    position: 'absolute',
                    top: 'calc(50% - 200px)', // Mover hacia arriba para dejar espacio para el texto
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    textAlign: 'center'
                  }}>
                    <Paper style={{width: '500px', border: '3px solid #156eb3'}}>
                      <Typography variant="h3" style={{color: '#5ea0d4'}}>
                        <strong> {textDialogVid} </strong> <br />
                      </Typography>
                    </Paper>
                  </div>


                  <div style={{
                    position: 'absolute',
                    top: 'calc(50% + 200px)', // Mover hacia abajo para dejar espacio para el texto
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    textAlign: 'center'
                  }}>
                    <Paper style={{width: '500px', backgroundColor: '#156eb3'}}>
                      <Typography variant="h3" style={{color: 'white'}}>
                        <strong> {textDialogVid} </strong> <br />
                      </Typography>
                    </Paper>
                  </div>
                </div>
          : 
            <div>
              {/* <Paper style={{display: 'flex', justifyContent: 'center', alignItems: 'center', padding:'10px'}}>
                <Typography variant="h4" style={{color: '#5ea0d4'}}>
                  <strong> REPITE ESTE VÍDEO </strong> <br />
                </Typography>
              </Paper> */}

              <video className={styles.signVideo} autoPlay muted onEnded={handleEndVidRefence} style={{width: '100%', height: '100%'}}>
                <source src={cameraTesterVidRef} type="video/mp4" />
              </video>
            </div>
          }
        </DialogContent>

      </Dialog>


      <Dialog className="sig_SignModal_Dialog" open={openDialogShowInfo!==pCameraTesterTab.none} onClose={() => setOpenDialogShowInfo(pCameraTesterTab.none)} style={{border: '2px solid red'}}>
        <DialogContent className="sig_SignModal_DialogContent" style={{padding: '10px', width: '650px', height: '550px'}}>
          <Paper style={{padding: '10px', width: '100%', height: '88%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>

            {openDialogShowInfo === pCameraTesterTab.position &&
            <>
              <Typography variant="h3" style={{padding: '30px', color: '#5ea0d4'}}>
                <strong> Control de posición </strong> <br />
              </Typography>
              <hr style={{ margin: '0 30px', flexGrow: '1', border: 'none', borderTop: 'none', borderLeft: '1px solid black' }} />
              <Typography variant="h5" style={{padding: '30px', color: '#5ea0d4'}}>
                <p><strong> 1. Posicionate frente a la camara </strong></p>
                <p><strong> 2. Aléjate </strong> un poco de la camara.</p>
                <p><strong> 3. La posición de tu cabeza y manos</strong> deben encajar dentro del galibo.</p>
              </Typography>
            </>
            }

            {openDialogShowInfo === pCameraTesterTab.video &&
            <>
              <Typography variant="h3" style={{padding: '30px', margin: '10px', color: '#5ea0d4'}}>
                <strong> Control de calidad </strong> <br />
              </Typography>
              <hr style={{ margin: '0 30px', flexGrow: '1', border: 'none', borderTop: 'none', borderLeft: '1px solid black' }} />
              <Typography variant="h5" style={{padding: '30px', color: '#5ea0d4'}}>
                <p><strong> 1. Te mostramos un vídeo </strong> de 4 segundos.<br /></p>
                <p><strong> 2. Repite lo que has visto</strong>, tienes 4 segundos para hacerlo. <br /></p>
                <p><strong> 3. Puntuaremos </strong> la calidad de la grabación.</p>
              </Typography>
            </>
            }
           
          </Paper>
          <div style={{margin: '5px', display: 'flex', justifyContent: 'center', backgroundColor: '#5ea0d4' }}>
            <Button onClick={()=> {stopTimer(); setOpenDialogShowInfo(pCameraTesterTab.none)}} style={{ width: '100%', height: '50px', color: 'white'}}> SALTAR </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* <Dialog className="sig_SignModal_Dialog" open={openWarningQuiet} onClose={() => setOpenWarningQuiet(false)} style={{border: '2px solid red'}}>
        <DialogContent className="sig_SignModal_DialogContent" style={{padding: '10px', width: '600px', height: '450px'}}>
          <Paper style={{padding: '10px', width: '100%', height: '45%', display: 'flex', justifyContent: 'center', alignItems: 'center', border: '1px solid #5ea0d4'}}>
            <Paper style={{padding: '10px', width: '100%', height: '20%', display: 'flex', justifyContent: 'center', alignItems: 'center', border: '3px solid #5ea0d4', backgroundColor: evalSuccess ? 'green' : 'red' }}>
              <Typography variant="h5" style={{padding: '30px', color: 'white', flex: 1, textAlign: "center"}}>
                <strong> ¿ Has repetido el vídeo ? </strong> <br />
              </Typography>
          </Paper>
            <Typography variant="h5" style={{padding: '30px', color: '#5ea0d4', flex: 1, textAlign: 'center'}}>
              <strong> NO HAY MOVIMIENTO DE MANOS </strong> <br />
            </Typography>
            <Typography variant="h7" style={{padding: '30px', color: '#5ea0d4', flex: 1}}>
              <p><strong> Repite la frase: LUZ CALIDAD REVISAR </strong></p>
            </Typography>
          </Paper>
        </DialogContent>
      </Dialog> */}


      <Dialog className="sig_SignModal_Dialog" open={openDialogScoreDetails} onClose={() => setOpenScoreDetails(false)} style={{border: '2px solid red'}}>
        <DialogContent className="sig_SignModal_DialogContent" style={{padding: '10px', width: '600px', height: '450px'}}>
          <Paper style={{padding: '10px', width: '100%', height: '20%', display: 'flex', justifyContent: 'center', alignItems: 'center', border: '3px solid #5ea0d4', backgroundColor: evalSuccess ? 'green' : 'red' }}>
              <Typography variant="h5" style={{padding: '30px', color: 'white', flex: 1, textAlign: "center"}}>
                <strong> Puntuación Global: {(avgScoreGLOBAL*100).toFixed(1)} </strong> <br />
              </Typography>
              <Typography variant="h7" style={{padding: '30px', color: 'white', flex: 1}}>
                { evalSuccess ?  <strong> Evaluación superada. Se ha superado umbral de 60 puntos. </strong> : <strong>  Evaluación no superada. No alcanza el umbral de 60 puntos. </strong> }
                <br />
              </Typography>
          </Paper>
          <Paper style={{padding: '10px', width: '100%', height: '45%', display: 'flex', justifyContent: 'center', alignItems: 'center', border: '1px solid #5ea0d4'}}>
            <Typography variant="h5" style={{padding: '30px', color: '#5ea0d4', flex: 1, textAlign: 'center'}}>
              <strong> Manos: {(avgScoreHANDS*100).toFixed(1)} </strong> <br />
            </Typography>
            <Typography variant="h7" style={{padding: '30px', color: '#5ea0d4', flex: 1}}>
              <p><strong> ¿ Cómo mejorar ? </strong></p>
              <p> 1. Manos dentro del cuadro. </p>
              <p> 2. Mejora la iluminación. </p>
              <p> 3. Evita movimientos muy bruscos. </p>
            </Typography>
          </Paper>
          <Paper style={{padding: '10px', width: '100%', height: '33%', display: 'flex', justifyContent: 'center', alignItems: 'center',border: '1px solid #5ea0d4'}}>
            <Typography variant="h5" style={{padding: '30px', color: '#5ea0d4', flex: 1, textAlign: 'center'}}>
              <strong> Cabeza: {(avgScoreHEAD*100).toFixed(1)} </strong> <br />
            </Typography>
            <Typography variant="h7" style={{padding: '30px', color: '#5ea0d4', flex: 1}}>
              <p><strong> ¿ Cómo mejorar ? </strong></p>
              <p> Cuando te coloques no cambies de posición. </p>
            </Typography>
          </Paper>
        </DialogContent>
          <div style={{marginTop: '-20px', display: 'flex', justifyContent: 'center', backgroundColor: '#5ea0d4' }}>
            <Button onClick={showTutorial} style={{ width: '100%', height: '50px', color: 'white'}}> Para más información </Button>
          </div>
      </Dialog>

    </>

  )}
